'use strict';
// The API record's seeded metadata owns per-prompt indexing. No second slug list.
function isPromptNoindex(prompt) {
  return !!prompt && typeof prompt === 'object' && (prompt.meta?.robots === 'noindex, follow' || prompt.robots === 'noindex, follow');
}
module.exports = Object.freeze({ isPromptNoindex });
